


































import Vue from 'vue'
import PeriodSelector from '@/components/sub-components/PeriodSelector.vue'
import { withSingularOrPluralLabel } from '@/utils/labels'
import moment from 'moment-timezone'
import { mapActions, mapGetters } from 'vuex'
import { PatientWithStatsActionNames, PatientWithStatsGetterNames } from '@/store/modules/patient-with-stats/keys'
import { ModuleNames } from '@/store/module-names'
import { ActionNames, GetterNames } from '@/store/modules/patient/keys'
import PatientSummary from '@/components/patients-summaries/PatientSummary.vue'
import { PATIENT_NOUN } from '@/constants/app-variables'

const weekLabels = ['WEEK', 'WEEKS']
export default Vue.extend({
  components: {
    PeriodSelector,
    PatientSummary,
  },
  data() {
    return {
      isInitialized: false,
      loading: true,
      displayWeeks: 6,
      periodOptions: [
        { weeks: 1, label: withSingularOrPluralLabel(1, weekLabels[0], weekLabels[1]) },
        { weeks: 2, label: withSingularOrPluralLabel(2, weekLabels[0], weekLabels[1]) },
        { weeks: 3, label: withSingularOrPluralLabel(3, weekLabels[0], weekLabels[1]) },
        { weeks: 4, label: withSingularOrPluralLabel(4, weekLabels[0], weekLabels[1]) },
        { weeks: 6, label: withSingularOrPluralLabel(6, weekLabels[0], weekLabels[1]) },
        { weeks: 8, label: withSingularOrPluralLabel(8, weekLabels[0], weekLabels[1]) },
        { weeks: 10, label: withSingularOrPluralLabel(10, weekLabels[0], weekLabels[1]) },
        { weeks: 12, label: withSingularOrPluralLabel(12, weekLabels[0], weekLabels[1]) },
        { weeks: Infinity, label: 'ALL' },
      ],
      patientNoun: PATIENT_NOUN,
    }
  },
  computed: {
    ...mapGetters(ModuleNames.patient, [GetterNames.patients]),
    ...mapGetters(ModuleNames.patientWithStats, [PatientWithStatsGetterNames.PatientWithStats]),
    startTimestamp() {
      if (this.displayWeeks === Infinity) return 1
      const start = moment(this.endTimestamp)
        .utc()
        .add(this.displayWeeks * -1, 'weeks')
        .add(1, 'day')
        .startOf('day')
      return start.valueOf()
    },
    patients() {
      return this[GetterNames.patients]
    },
    patientWithStats() {
      return this[PatientWithStatsGetterNames.PatientWithStats]
    },
    endTimestamp() {
      const end = moment()
        .utc()
        .endOf('day')
      return end.valueOf()
    },
  },
  async created() {
    await Promise.all([this[ActionNames.getPatients](), this.fetchPatientWithStats()])
    this.isInitialized = true
  },
  methods: {
    ...mapActions(ModuleNames.patient, [ActionNames.getPatients]),
    ...mapActions(ModuleNames.patientWithStats, [PatientWithStatsActionNames.getPatientWithStats]),
    async fetchPatientWithStats(options): Promise<void> {
      this.loading = true
      await this[PatientWithStatsActionNames.getPatientWithStats]({
        startTimestamp: this.startTimestamp,
        endTimestamp: this.endTimestamp,
      })
      this.loading = false
    },
    async selectPeriod(option): Promise<void> {
      this.displayWeeks = option.weeks
      await this.fetchPatientWithStats()
    },
  },
})
